/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./veditor-usage.vue?vue&type=template&id=b9d6ec44&scoped=true&"
import script from "./veditor-usage.vue?vue&type=script&lang=js&"
export * from "./veditor-usage.vue?vue&type=script&lang=js&"
import style0 from "./veditor-usage.vue?vue&type=style&index=0&id=b9d6ec44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d6ec44",
  null
  
)

export default component.exports